function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUndo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.08 8.68"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#d8d8d8",
    opacity: 0.5
  },
  d: "M13.08 3.69H2.48L5.25.91 4.34 0 .91 3.42l-.26.27-.38.38-.27.27.27.27.38.38.26.26 3.43 3.43.91-.92-2.77-2.77h10.6v-1.3z",
  "data-name": "Ebene 1"
})));

export default SvgUndo;